import React, { useState } from "react";
import axios from "axios";

const useComponent = ({
    onFinish = ({ axiosMode, status, values }) => {},
    onBefore = ({ axiosMode, status }) => {},
}) => {
    let mainAPI = "/dynamicWebsite/frontend/frontend_component";
    const [data, setData] = useState([]);
    const getComponentData = (params) => {
        onBefore({
            axiosMode: "get",
        });
        return axios
            .get(mainAPI, {
                params: params,
            })
            .then((response) => {
                let data = response.data || [];
                setData(data?.data);
                if (data) {
                    onFinish({
                        axiosMode: "get",
                        status: "success",
                    });
                } else {
                    onFinish({
                        axiosMode: "get",
                        status: "error",
                    });
                }

                return {
                    ...data,
                };
            })
            .catch((error) => {
                if (!axios.isCancel(error)) {
                }
            });
    };
    const postComponentData = (data) => {
        onBefore({
            axiosMode: "post",
        });
        axios
            .post(mainAPI, data)
            .then((response) => {
                let responseData = response.data;
                let status = responseData?.status;
                if (status === "success") {
                    onFinish({
                        axiosMode: "post",
                        status: "success",
                    });
                } else {
                    onFinish({
                        axiosMode: "post",
                        status: "error",
                    });
                }
            })
            .catch(() => {
                onFinish({
                    axiosMode: "post",
                    status: "error",
                });
            });
    };
    const patchComponentData = (data) => {
        onBefore({
            axiosMode: "patch",
        });
        axios
            .patch(mainAPI, data)
            .then((response) => {
                let responseData = response.data;
                let status = responseData?.status;
                if (status === "success") {
                    onFinish({
                        axiosMode: "patch",
                        status: "success",
                    });
                } else {
                    onFinish({
                        axiosMode: "patch",
                        status: "error",
                    });
                }
            })
            .catch(() => {
                onFinish({
                    axiosMode: "patch",
                    status: "error",
                });
            });
    };
    const deleteComponentData = (data) => {
        onBefore({
            axiosMode: "delete",
        });
        axios
            .delete(mainAPI, {
                data,
            })
            .then((response) => {
                let responseData = response.data;
                let status = responseData?.status;
                if (status === "success") {
                    onFinish({
                        axiosMode: "delete",
                        status: "success",
                    });
                } else {
                    onFinish({
                        axiosMode: "delete",
                        status: "error",
                    });
                }
            })
            .catch(() => {
                onFinish({
                    axiosMode: "delete",
                    status: "error",
                });
            });
    };
    return {
        ComponentData: data,
        getComponentData,
        postComponentData,
        patchComponentData,
        deleteComponentData,
    };
};
export { useComponent };
